import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class ReportsPatientsExcel {
    exportExcel(data) {
        let option = {};  // La opción representa el archivo de Excel
        let closuresOfCashReceipts = this.dataReportPatiensExport(data);
        option.fileName = 'Reporte de Pacientes';  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: closuresOfCashReceipts.data,  // Fuente de datos en archivo Excel
                sheetName: 'Reporte de Pacientes',  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel
    }

    dataReportPatiensExport(dataPatients) {
        let dataTable = [];
        let CasillasTitulos = this.generarTitulos();
        dataTable.push(CasillasTitulos);
        for (let i = 0; i < dataPatients.length; i++) {
            let infoDetallada = this.generarInformacionDetallada(dataPatients[i]);
            dataTable.push(infoDetallada);
        }

        let sheet =
        {
            data: dataTable
        }

        return sheet;
    }

    generarTitulos() {
        let casillas = {
            '1': "Fecha de la Admisión",
            '2': "Tipo de Documento",
            '3': "Número de Documento",
            '4': "Nombre del Paciente",
            '5': "Entidad",
            '6': "Atorización",
            '7': "Servicio",
            '8': "CUPS",
            '9': "Profesional",
            '10': "Admisión",
            '11': "Estado de la Admisión",
            '12': "Usuario Admisión",
            '13': "Reagendado",
            '14': "Admisión Padre",
            '15': "Recibo de Caja",
            '16': "Usuario Cajero",
            '17': "Recibo Anulado",
            '18': "Fecha Aplicación Radiofarmaco",
            '19': "Radiofarmaco Aplicado",
            '20': "Dosis Radiofarmaco",
            '21': "Tecnologo",
            '22': "Imagenes Tecnologo",
            '23': "Fecha y Hora Ultima Subida Imagenes",
            '24': "Imagenes Profesional",
            '25': "Posee Transcripción",
            //'21': "Historia Clínica Cerrada",
            '26': "Factura",
            '27': "Usuario Facturador",
            '28': "Fecha de Radicación",
            '29': "Fecha de Vencimiento",
            '30': "Nota Crédito",
            '31': "Total Facturado",
            '32': "Recibido",
            '33': "Total Entidad"
        }
        return casillas;
    }

    generarInformacionDetallada(data) {
        let casillas = {
            '1': data.fecha_admision != null && data.fecha_admision != undefined && data.fecha_admision != "" ? moment(data.fecha_admision).format("DD/MM/YYYY") : "N/a",
            '2': data.tipo_documento_paciente != null && data.tipo_documento_paciente != undefined && data.tipo_documento_paciente != "" ? data.tipo_documento_paciente : "N/a",
            '3': data.num_documento_paciente != null && data.num_documento_paciente != undefined && data.num_documento_paciente != "" ? data.num_documento_paciente : "N/a",
            '4': data.nombre_paciente != null && data.nombre_paciente != undefined && data.nombre_paciente != "" ? data.nombre_paciente : "N/a",
            '5': data.contrato_tercero != null && data.contrato_tercero != undefined && data.contrato_tercero != "" ? data.contrato_tercero : "N/a",
            '6': data.codigo_autorizacion != null && data.codigo_autorizacion != undefined && data.codigo_autorizacion != "" ? data.codigo_autorizacion : "N/a",
            '7': data.servicio_realizado != null && data.servicio_realizado != undefined && data.servicio_realizado != "" ? data.servicio_realizado : "N/a",
            '8': data.cups_realizado != null && data.cups_realizado != undefined && data.cups_realizado != "" ? data.cups_realizado : "N/a",
            '9': data.nombre_profesional != null && data.nombre_profesional != undefined && data.nombre_profesional != "" ? data.nombre_profesional : "N/a",
            '10': data.id_admision != null && data.id_admision != undefined && data.id_admision != "" ? data.id_admision : "N/a",
            '11': data.estado_admision != null && data.estado_admision != undefined && data.estado_admision != "" ? data.estado_admision.toUpperCase() : "N/a",
            '12': data.usuario_recepcion_nombre != null && data.usuario_recepcion_nombre != undefined && data.usuario_recepcion_nombre != "" ? data.usuario_recepcion_nombre : "N/a",
            '13': data.id_admision_padre != null && data.id_admision_padre != undefined && data.id_admision_padre != "" ? "SI" : "NO",
            '14': data.id_admision_padre != null && data.id_admision_padre != undefined && data.id_admision_padre != "" ? data.id_admision_padre : "N/a",
            '15': data.num_recibo != null && data.num_recibo != undefined && data.num_recibo != "" ? data.num_recibo : "N/a",
            '16': data.usuario_cajero != null && data.usuario_cajero != undefined && data.usuario_cajero != "" ? data.usuario_cajero : "N/a",
            '17': data.recibo_cancelado == true ? "SI" : "NO",
            '18': data.fecha_aplicacion_radiofarmaco != undefined && data.fecha_aplicacion_radiofarmaco != null && data.fecha_aplicacion_radiofarmaco != "" ? moment(data.fecha_aplicacion_radiofarmaco).format("DD/MM/YYYY") : "N/a",
            '19': data.radiofarmaco_aplicado_admision != undefined && data.radiofarmaco_aplicado_admision != null && data.radiofarmaco_aplicado_admision != "" ? data.radiofarmaco_aplicado_admision : "N/a",
            '20': data.dosis_radiofarmaco_admision != undefined && data.dosis_radiofarmaco_admision != null && data.dosis_radiofarmaco_admision != "" ? data.dosis_radiofarmaco_admision : "N/a",
            '21': data.tecnologo_admision != null && data.tecnologo_admision != undefined && data.tecnologo_admision != "" ? data.tecnologo_admision : "N/a",
            '22': data.imagenes_diagnosticas_data != null && data.imagenes_diagnosticas_data != undefined && data.imagenes_diagnosticas_data != "" ? data.imagenes_diagnosticas_data : "N/a",
            '23': data.fecha_ultima_imagen != null && data.fecha_ultima_imagen != undefined && data.fecha_ultima_imagen != "" ? data.fecha_ultima_imagen : "N/a",
            '24': data.estado_imagenes_doctor != null && data.estado_imagenes_doctor != undefined && data.estado_imagenes_doctor != "" ? data.estado_imagenes_doctor : "N/a",
            '25': data.estado_transcripcion != null && data.estado_transcripcion != undefined && data.estado_transcripcion != "" ? data.estado_transcripcion : "N/a",
            //'21': data.historia_cerrada == true ? "Aplicada" : "Sin Aplicar",
            '26': data.num_fac_ter != null && data.num_fac_ter != undefined && data.num_fac_ter != "" ? data.num_fac_ter : "N/a",
            '27': data.nombre_usuario_facturador != null && data.nombre_usuario_facturador != undefined && data.nombre_usuario_facturador != "" ? data.nombre_usuario_facturador : "N/a",
            '28': data.fecha_radicacion != null && data.fecha_radicacion != undefined && data.fecha_radicacion != "" ? moment(data.fecha_radicacion).format("DD/MM/YYYY") : "N/a",
            '29': data.fecha_vencimiento != null && data.fecha_vencimiento != undefined && data.fecha_vencimiento != "" ? data.fecha_vencimiento : "N/a",
            '30': data.nota_credito != null && data.nota_credito != undefined && data.nota_credito != "" ? data.nota_credito : "N/a",
            '31': data.subtotal_recibo != null && data.subtotal_recibo != undefined && data.subtotal_recibo != "" ? data.subtotal_recibo : "0",
            '32': data.copago_recibo != null && data.copago_recibo != undefined && data.copago_recibo != "" ? data.copago_recibo : "0",
            '33': data.total_recibo != null && data.total_recibo != undefined && data.total_recibo != "" ? data.total_recibo : "0",
        }
        return casillas;
    }

}

export default new ReportsPatientsExcel();